exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menuHeaderText{margin-left:2em;font-size:75%;color:#aaa;text-transform:uppercase}.menuHeader{margin-top:20px;margin-bottom:0}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/dist/cjs.js!./src/components/Sidebar/components/MenuHeader/style.scss
// module id = 6184
// module chunks = 0